// @flow
import React from "react"
import { type HOC } from "recompose"
import withQuery from "hoc/withQuery"
import urls from "data/router/urls"
import type { ID } from "data/enums/types"
import { productDetailQuery } from "data/product/graphql/queries"
import SubPage from "pages/_Page/SubPage"
import CreateReservationForm from "./CheckoutForm"

const Checkout = ({ data, match }) => {
  const variantAffiliate = data.affiliates.find(
    a => a.affiliateId === +match.params.affiliateId,
  )
  if (!variantAffiliate) return null

  return (
    <SubPage
      title="Checkout"
      backUrl={urls.cart(data.id, variantAffiliate.affiliateId)}
    >
      {variantAffiliate && (
        <CreateReservationForm
          productVariant={data}
          variantAffiliate={variantAffiliate}
        />
      )}
    </SubPage>
  )
}

type Outter = {|
  match: {|
    params: {|
      productVariantId: ID,
      affiliateId: ID,
    |},
  |},
|}

const enhancer: HOC<*, Outter> = withQuery(productDetailQuery, {
  variables: props => ({
    affiliateId: props.match.params.affiliateId,
    productVariantId: props.match.params.productVariantId,
  }),
})

export default enhancer(Checkout)



// WEBPACK FOOTER //
// ./src/pages/Checkout/index.js